module.exports = __webpack_public_path__ + "media/subway/T-9223b038.png";